<template>
	<div class="item_sidebar border_item_sidebar size-value-panel" :class="addedClass">
		<div class="wrapper_title" :class="{'mb_15':panelOpen}">
			<div class="title">{{title}}</div>
			<a class="sidebar_item_open_arrow" :class="{'active':panelOpen}" @click="panelOpenToggle">
				<img src="@/modules/page-editor/src/assets/img/chevron-up.svg" alt="">
			</a>
		</div>

	<div v-show="panelOpen" class="layout-column">
		<!-- add 'single_item' to addedClass for the single element -->
		<div class="sv-row flex-none layout-row">
			<div class="subtitle">Width</div>
			<div class="flex"></div>
			<input-field type="number" small :value.number="size.width" append="px"
			             placeholder="auto" :step="10"
			             @input="inputDataUpdate($event, 'width')" :min="0" :max="10000"/>
		</div>
		<div class="sv-row flex-none layout-row">
			<div class="subtitle" >Height</div>
			<div class="flex"></div>
			<input-field type="number" small :value.number="size.height" append="px"
			             placeholder="auto" :step="10"
			             @input="inputDataUpdate($event,'height')" :min="0" :max="10000"/>
		</div>
	</div>
	</div>
</template>

<script>
import InputField from '@/components/base/input-field';

export default {
	name: 'SizeValue',
	props: ['value', 'title', 'addedClass'],
	components: {InputField},
	data: function () {
		return {
			panelOpen: true,
			localValue: {
				width: 0,
				height: 0,
			},
		}
	},
	computed: {
		size() {
			return {...this.localValue, ...this.value}
		}
	},
	methods: {
		panelOpenToggle(){
			this.panelOpen = !this.panelOpen;
			localStorage.setItem('SizeValue.'+this.title, this.panelOpen);
		},
		inputDataUpdate(val, prop) {
			if (val) {
				this.localValue[prop] = parseInt(val);
			} else {
				this.localValue[prop] = null;
			}
			this.$emit('updated', this.localValue);
		},
	},
	created() {
		this.localValue = JSON.parse(JSON.stringify(this.value));
	}
}
</script>
<style lang="scss" scoped>
.size-value-panel {
	.subtitle {
		margin-left: 30px;
	}
	.sv-row {
		align-items: center;
		&:first-child {
			margin-bottom: 5px;
		}
	}
	.input-field {
		width: 100px;
	}
}
</style>
